// extracted by mini-css-extract-plugin
export default {"formSection":"FormSection_formSection__PqDud","container":"FormSection_container__M6xGx","inputForm":"FormSection_inputForm__yl3zR"};